<template>
  <div class="chart-container">
    <h1>{{name}}</h1>
    <highcharts
      class="chart"
      :options="options"
    />
  </div>
</template>

<script>


function buildLineChartConfig({data,type,pointLabel}){
  const opts =  {
      chart: {
        className: 'highcharts-chart',
        type: type,
        backgroundColor: '#181a25',
      },
      title: {
        text: null
      },
      xAxis: {
        visible: true,
        categories: null // TBD
      },
      yAxis: {
        gridLineColor: null,
        gridLineWidth: 0,
        labels: {
          style: {
            fontFamily: "Akkurat Pro",
            fontWeight: "600",
            fontSize: "1em",
            color: "#e0e3ed80",
            transform: "translateY(-1px)"
          }
        },
        title: {
          text: null
        },
      },
      credits: { enabled: false },
      exporting: { enabled: false },
      tooltip: {
        crosshairs: true,
        shared: true,
        backgroundColor: "#181a25",
        borderColor: "transparent",
        shadow: false,
        style: {
          fontFamily: "Akkurat Pro",
          color: "#e0e3ed",
          boxShadow: "none"
        },
      },
      legend: {
        itemStyle: {
          color: "#e0e3ed",
          fontFamily: "Akkurat Pro",
          fontWeight: 400,
          fontSize: "1.2em"
        }
      },
      plotOptions: {
        spline: {
          marker: { enabled: false, },
        },
        series: {
          lineWidth: 3,
        },
      },
      series: [{
        color: '#7CB5EC',
        name: pointLabel,
        data: null, // TBD
        marker: {
          enabled: false
        }
      }]
    }

    if(!data){
      return opts
    }

    const xAxis = []
    const yAxis = []

    for(const [x,y] of data){
      xAxis.push(x)
      yAxis.push(y)
    }

    opts.xAxis.categories = xAxis
    opts.series[0].data = yAxis

    return opts
}


export default {
  name: 'LineChart',
  data () {
    return {
      options: buildLineChartConfig({
        data: null,
        pointLabel: this.pointLabel,
        type: this.type
      })
    }
  },
  props: ['name','type','pointLabel','data'],
  watch: {
    data: function(newData){
      this.options = buildLineChartConfig({
        data: newData,
        pointLabel: this.pointLabel,
        type: this.type
      })
    }
  },
  components: {}
};
</script>


<style scoped>
.chart-container{
  display: inline-block;
  width: calc(50% - 42px);
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataviews/BasicChart.vue